import { SizeType } from '~/lib/ApiModel';
import { SelectButtonList, SelectButtonItem } from '~/components/SelectButtonList';
import React from 'react';

export type SizeTypeSelectorProps = {
    sizeTypes: SizeType[];
    selected?: string;
    onSizeTypeSelected?: (selected: SizeType) => unknown;
};

export default class SizeTypeSelector extends React.Component<SizeTypeSelectorProps> {
    render() {
        return (
            <div className="sizeTypeSelector">
                <SelectButtonList legend="Server size">
                    {this.props.sizeTypes.map((p) => (
                        <SelectButtonItem
                            key={p.slug}
                            isSelected={p.slug === this.props.selected}
                            onSelect={() => this.props.onSizeTypeSelected?.(p)}
                        >
                            {p.name}
                        </SelectButtonItem>
                    ))}
                </SelectButtonList>
            </div>
        );
    }
}
